// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"HtmlInputField_inputWrapper__xsAmW","html-input-label-actions":"HtmlInputField_html-input-label-actions__tYmhe"};